<template>
    <div class="myApply-page">
        <div class="fd-banner">
            <div class="fd-title-inner">
                <img class="apply-img" src="../../assets/image/apply.png" alt="">
            </div>
        </div>
        <div class="fdpply-head">
            <van-icon class="left-icon" name="arrow-left" @click="goBack(isSubmit)"/>
            <div class="title-center">
                <h3>我的申请</h3>
            </div>
            <van-icon class="right-icon" name="wap-home-o" @click="goHome"/>
        </div>
        <div class="fd-apply-sort">
        <!--<div class="fd-dbapply-sort">-->
            <h4 class="bq-title">保全类申请</h4>
            <ul class="bq-apply">
                <li v-for="(item,index) in bqList" :key="index"
                @click="tabApply(item.name)">
                    <div class="img-box">
                        <img :src="item.ImgUrl" alt="">
                    </div>
                    <span>{{item.title}}</span>
                </li>
            </ul>
        </div>
        <div class="fd-dbapply-sort">
            <h4 class="db-title">担保类申请</h4>
            <ul class="bq-apply">
                <li v-for="(item,index) in dbList" :key="index"
                @click="tabApply(item.name)">
                    <div class="img-box">
                        <img :src="item.ImgUrl" alt="">
                    </div>
                    <span>{{item.title}}</span>
                </li>
                <li></li>
            </ul>
        </div>
    </div>
</template>

<script>
// import {getJcbqsqList} from '../../myPreservation/request.js';
    export default {
        data() {
            return {
                bqList:[
                    {
                        name:"myPreservation",
                        ImgUrl:require("../../assets/image/bq.png"),
                        title:"保全申请"
                    },
                    {
                        name:"myReconsider",
                        ImgUrl:require("../../assets/image/fy.png"),
                        title:"复议申请"
                    },
                    {
                        name:"myRelievPreservation",
                        ImgUrl:require("../../assets/image/fy.png"),
                        title:"解保申请"
                    },
                    {
                        name:"myContinuationPreservation",
                        ImgUrl:require("../../assets/image/fy.png"),
                        title:"续保申请"
                    }
                ],
                dbList:[
                    {
                        name:"myGuarantee",
                        ImgUrl:require("../../assets/image/db.png"),
                        title:"担保申请"
                    },
                ],
            }
        },
        mounted() {

        },
        methods: {
             goBack() {
                 // history.go(-1)
                 // 返回到我的申请里面
                 this.$router.push('/home/index');
            },
            goHome() {
                this.$router.push('/home/index')
            },
            tabApply(name){
                if(name == "myPreservation"){
                    this.$router.push("/home/myPreservation");
                }else if(name == "myReconsider"){
                    this.$router.push("/home/myReconsider");
                }else if(name == "myRelievPreservation"){
                    this.$router.push("/home/myRelievPreservation");
                }else if(name == "myContinuationPreservation"){
                    this.$router.push("/home/myContinuationPreservation");
                }else if(name == "myGuarantee"){
                    this.$router.push("/home/myGuarantee");
                }
            }
        },
        created() {

        },
    }
</script>

<style lang="less" rel="stylesheet/less" scoped>
    .myApply-page {
        width: 100%;
        height: 100%;
        overflow: auto;
        background: #f3f3f3;
        position: relative;
    }
    .fd-banner {
        width: 100%;
        height: 100%;
        background: url('../../assets/image/head.png') no-repeat center center;
        position: absolute;
        top: 0;
    }
    .fdpply-head {
        box-sizing: border-box;
        padding: 12px 10px 0 10px;
        height: 44px;
        line-height: 44px;
        display: flex;
        width: 100%;
        justify-content: space-between;
        position: absolute;
        top: 0;
        z-index: 2;

        .left-icon, .right-icon {
            font-size: 24px;
            color: #fff;
            line-height: 44px;
        }
        h3 {
            font-size: 18px;
            font-weight: normal;
            white-space: nowrap;
            padding-right: 8px;
            color: #fff;
        }
    }
    .fd-apply-sort{
        position: absolute;
        top: 244px;
        z-index: 2;
        width: 92%;
        margin-left: 4%;
    }
    .bq-title,.db-title{
        font-size: 22px;
        color: #fff;
        font-weight:600;
        letter-spacing:2px;
    }
    .db-title{
        color: #0683fc;
    }
    .bq-apply{
        width: 100%;
        height: 105px;
        background: #fff;
        margin-top: 10px;
        border-radius: 6px;
        box-shadow: 0px 6px 10px #e5e5e5;
        display: flex;
        >li{
            width:calc(100% / 3);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .img-box{
                width: 42px;
                height: 42px;
                background: #0683fc;
                border-radius: 50%;
                overflow: hidden;
            }
            .img-box>img{
                width: 60%;
                height: 60%;
                display: block;
                line-height: 40px;
                margin: 20% auto;
            }
            >span{
                color: #818898;
                margin-top: 10px;
            }
        }
        >li:nth-child(1),li:nth-child(2),li:nth-child(3){
            border-right: 1px solid #cccccc;
        }
    }
    .fd-dbapply-sort{
        position: absolute;
        top: 398px;
        z-index: 2;
        width: 92%;
        margin-left: 4%;
    }
    .apply-img{
        width: 100%;
        height: 100%;
        display: inline-block;
        margin-top:17%;
    }
</style>
